import React from 'react'
import styled from 'styled-components'

import Heading from '../atoms/Heading'
import Image from '../atoms/Image'

const Container = styled.aside`
  margin: 30px 0 35px;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    align-items: center;
    display: flex;
    margin: 100px 200px 50px;
  }
`

const DesktopRightContainer = styled.div`
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    flex: 1;
    margin: 0 0 0 50px;
  }
`

const Screenshot = styled.div`
  margin: 10px auto 0;
  width: 190px;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    width: 290px;
  }
`

const Logo = styled.div`
  margin: 0 auto;
  width: 240px;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    margin: 0;
    width: 270px;
  }
`

const Description = styled.div`
  margin: 20px 15px 0;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    margin: 25px 0 0;
  }
  @media (max-width: ${({ theme }) => theme.mediaQuery.mobile.maxWidth}) {
    br {
      display: none;
    }
  }
`

const TextRow = styled.p<{ bold?: boolean }>`
  color: ${({ theme }) => theme.palette.font.main};
  font-size: 12px;
  font-weight: ${({ bold }) => (bold ? 'bold' : 'normal')};
  margin: 16px 0 0;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    font-size: ${({ bold }) => (bold ? '14px' : '12px')};
  }
`

const Notes = styled.p`
  color: ${({ theme }) => theme.palette.font.gray};
  font-size: 10px;
  margin: 25px 15px 0;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    margin: 20px 0 0;
  }
`

export default function AwardDescription() {
  return (
    <Container>
      <Heading>ママリ口コミ大賞の想い</Heading>
      <Screenshot>
        <Image alt="スクリーンショット" filename="screenshot.png" />
      </Screenshot>
      <DesktopRightContainer>
        <Logo>
          <Image alt="ママリ口コミ大賞 ロゴ" filename="logo.png" />
        </Logo>
        <Description>
          <TextRow bold>主役は先輩ママの口コミ。</TextRow>
          <TextRow>
            子育てをスタートした全国のママとその家族が、納得してお買い物できる未来のために。
            <br />
            第8回となる今回は、4,415件の口コミの中から&nbsp;&quot;後輩ママにおすすめしたい&quot;&nbsp;34部門128商品を厳選しました。
          </TextRow>
          <TextRow>
            2021年に出産したママの3人に1人 <small>※</small> が会員登録する「ママリ」 がおくる、
            先輩ママの「本当に使ってよかった」を紹介する取り組みが「ママリ口コミ大賞」です。
          </TextRow>
        </Description>
        <Notes>
          ※：「ママリ」で2021年内に出産予定と設定したユーザー数と、厚生労働省発表「人口動態統計」の出生数から算出。
        </Notes>
      </DesktopRightContainer>
    </Container>
  )
}
